import React from 'react';
import { Link } from 'react-router-dom';
import PublicLayout from '../components/public/PublicLayout';
import { BookOpen, FileText, GraduationCap, Scale, HelpCircle, Stethoscope } from 'lucide-react';

const ResourcesHubPage = () => {
  const resources = [
    {
      icon: BookOpen,
      title: 'Publications & Reports',
      description: 'Access our research papers, clinical guidelines, and annual reports',
      color: 'primary',
      link: '/resources/publications'
    },
    {
      icon: GraduationCap,
      title: 'Training Materials',
      description: 'Educational resources for respiratory care professionals',
      color: 'success',
      link: '/resources/training-materials'
    },
    {
      icon: FileText,
      title: 'Policy Documents',
      description: 'Guidelines, protocols, and policy recommendations',
      color: 'info',
      link: '/resources/policy-documents'
    },
    {
      icon: Scale,
      title: 'Policy Development',
      description: 'Latest policy updates and advocacy initiatives',
      color: 'warning',
      link: '/resources/policy-developments'
    },
    {
      icon: Stethoscope,
      title: 'Clinical Guidelines',
      description: 'Best practices and clinical protocols for respiratory care',
      color: 'danger',
      link: '/resources/clinical-guidelines'
    },
    {
      icon: HelpCircle,
      title: 'FAQs',
      description: 'Frequently asked questions about ARCA and respiratory care',
      color: 'secondary',
      link: '/resources/faqs'
    }
  ];

  return (
    <PublicLayout>
      <div className="py-5">
        <div className="container">
          {/* Header */}
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8">
              <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4" 
                   style={{ width: '80px', height: '80px', backgroundColor: '#6B8E23' }}>
                <BookOpen className="text-white" size={48} />
              </div>
              <h1 className="display-4 fw-bold text-dark mb-3">Resources</h1>
              <p className="lead text-muted">
                Comprehensive resources for respiratory care professionals, researchers, and healthcare providers
              </p>
            </div>
          </div>

          {/* Resources Grid */}
          <div className="row g-4 mb-5">
            {resources.map((resource, index) => {
              const Icon = resource.icon;
              return (
                <div key={index} className="col-md-6 col-lg-4">
                  <Link to={resource.link} style={{ textDecoration: 'none' }}>
                    <div className="card h-100 shadow-sm border-0" style={{ transition: 'all 0.3s', borderColor: '#6B8E23', borderWidth: '2px' }}>
                      <div className="card-body p-4 text-center">
                        <div className="mb-3 d-flex justify-content-center">
                          <div className="rounded-circle p-3" style={{ backgroundColor: '#e8f5e9' }}>
                            <Icon style={{ color: '#6B8E23' }} size={40} />
                          </div>
                        </div>
                        <h5 className="fw-bold text-dark mb-3">{resource.title}</h5>
                        <p className="text-muted mb-0">{resource.description}</p>
                      </div>
                      <div className="card-footer border-0 text-center" style={{ backgroundColor: '#e8f5e9' }}>
                        <span className="fw-semibold" style={{ color: '#6B8E23' }}>
                          Explore <i className="fas fa-arrow-right ms-2"></i>
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>

          {/* Additional Info Section */}
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="card shadow-sm border-0">
                <div className="card-body p-5">
                  <h3 className="h4 fw-bold text-dark mb-4">About Our Resources</h3>
                  <p className="text-muted mb-3">
                    ARCA provides a comprehensive collection of resources to support respiratory care professionals, 
                    educators, researchers, and policymakers across Africa. Our resources are regularly updated to 
                    reflect the latest evidence-based practices and guidelines.
                  </p>
                  
                  <div className="row g-4 mt-4">
                    <div className="col-md-6">
                      <h5 className="fw-bold text-dark mb-3">For Members</h5>
                      <ul className="list-unstyled">
                        <li className="mb-2"><i className="fas fa-check-circle text-success me-2"></i>Exclusive access to premium content</li>
                        <li className="mb-2"><i className="fas fa-check-circle text-success me-2"></i>Downloadable training materials</li>
                        <li className="mb-2"><i className="fas fa-check-circle text-success me-2"></i>Early access to new publications</li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <h5 className="fw-bold text-dark mb-3">Stay Updated</h5>
                      <ul className="list-unstyled">
                        <li className="mb-2"><i className="fas fa-bell text-primary me-2"></i>Subscribe to get notifications</li>
                        <li className="mb-2"><i className="fas fa-envelope text-primary me-2"></i>Monthly resource newsletters</li>
                        <li className="mb-2"><i className="fas fa-bookmark text-primary me-2"></i>Save your favorite resources</li>
                      </ul>
                    </div>
                  </div>

                  <div className="mt-4 text-center">
                    <Link to="/membership_registration" className="btn btn-lg me-3 fw-bold text-white" style={{ backgroundColor: '#6B8E23' }}>
                      Become a Member
                    </Link>
                    <Link to="/contact" className="btn btn-outline-secondary btn-lg">
                      Request Resources
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .hover-shadow:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
        }
      `}</style>
    </PublicLayout>
  );
};

export default ResourcesHubPage;
